import React from 'react';

import cx from 'classnames';

import { Status } from '@xingternal/hops';
import { FormattedMessage } from 'react-intl';
import { BodyCopy } from '@xingternal/typography';
import { Button } from '@xingternal/button';
import { useEditContext } from '@xingternal/pages-common';

import { InfoStateProps } from './types';
import styles from './InfoState.css';

const InfoState: React.FunctionComponent<InfoStateProps> = ({
  icon,
  headlineCopyKey,
  headlineCopy,
  headlineClass,
  bodyClass,
  textCopyKey,
  className,
  testId,
  buttonProps = [],
  additionalInfo,
  customButton,
  statusCode,
}) => {
  const { isEditing } = useEditContext();
  const hasCopyKey = headlineCopyKey && !headlineCopy;

  const buttonPropsList =
    buttonProps && Array.isArray(buttonProps) ? buttonProps : [buttonProps];

  return (
    <>
    {statusCode && <Status code={Number(statusCode)} />}
    <div
      className={cx(
        styles.infoStateWrapper,
        isEditing
          ? styles.infoStateWrapperEditor
          : styles.infoStateWrapperViewer,
        { [styles.noIcon]: !icon },
        className
      )}
      data-testid={testId}
    >
      {icon && (
        <div className={styles.iconWrapper}>
          {typeof icon === 'string' ? (
            <img className={styles.icon} src={icon} alt={'Icon'} />
          ) : (
            icon
          )}
        </div>
      )}
      <div className={styles.info}>
        <div>
          <div className={styles.textWrapper}>
            <BodyCopy
              fontWeight="bold"
              lineHeight="dense"
              size="xlarge"
              noMargin
              className={cx(headlineClass, styles.headerText)}
            >
              {hasCopyKey && <FormattedMessage id={headlineCopyKey} />}
              {!hasCopyKey && headlineCopy}
            </BodyCopy>
            <BodyCopy
              noMargin
              size="small"
              className={cx(bodyClass, styles.text)}
            >
              <FormattedMessage id={textCopyKey} />
            </BodyCopy>
          </div>
        </div>
        {additionalInfo && (
          <div className={styles.extra_content}>{additionalInfo}</div>
        )}
      </div>
      {buttonPropsList.length > 0 && (
        <div className={styles.ctaContainer}>
          {buttonPropsList.map((props) => (
            <Button
              size="small"
              sizeConfined="medium"
              variant={isEditing ? 'secondary' : 'tertiary'}
              {...props}
              className={cx(styles.button, props.className)}
              key={props.copyKey}
            >
              <FormattedMessage
                id={props.copyKey}
                defaultMessage={props.copyKey}
              />
            </Button>
          ))}
        </div>
      )}
      {customButton !== null && customButton}
    </div>
    </>
  );
};

export default InfoState;